import type { EmailSchemaBuilder } from 'hb-builder/utils/migrate/schemas/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';

const needMigration = (doc: DocumentItem, date: string) =>
  doc?.attributes?.lastSave &&
  new Date(doc.attributes.lastSave).getTime() < new Date(date).getTime();

const schemas = [
  ({ document }: EmailSchemaBuilder) => {
    if (needMigration(document, '2022-07-01')) {
      return {
        Text: {
          attributes: () => ({
            textBackgroundColor: () => null,
          }),
        },
      };
    }

    return null;
  },
  ({ document }: EmailSchemaBuilder) => {
    if (needMigration(document, '2023-07-23')) {
      return {
        Column: {
          attributes: (attr) => ({
            verticalAlign: () => {
              if (attr.verticalAlign === true) {
                return 'top';
              }

              return attr.verticalAlign;
            },
          }),
        },
        Section: {
          attributes: (attr) => ({
            verticalAlign: () => {
              if (attr.verticalAlign === true) {
                return 'top';
              }

              return attr.verticalAlign;
            },
          }),
        },
        Hero: {
          attributes: () => ({
            fullWidth: () => false,
          }),
        },
      };
    }

    return null;
  },
  ({ document }: EmailSchemaBuilder) => {
    // Add category to all single components
    if (needMigration(document, '2023-10-01')) {
      return {
        EmailImage: {
          category: () => 'single',
        },
      };
    }

    return null;
  },
];

export default schemas;
